import { BaseLayoutFactory } from "../global/base-layout-factory";
import { OfficialDailyProvider } from "./context/official-daily-context";
import { OfficialDailyComponent } from "./official-daily-component";

export function OfficialDailyFactory() {
    return (
        <BaseLayoutFactory>
            <OfficialDailyProvider>
                <OfficialDailyComponent />
            </OfficialDailyProvider>
        </BaseLayoutFactory>
    );
}
